import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import CommunicateStep from "../../../../../../../shared/wizard/steps/communicateStep";
import { EDealRequestCommunicationType } from "../../../../../../../shared/wizard/steps/types";

interface IWishStepBuy_1 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestCommunicationType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishStepBuy_1 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IWishStepBuy_1) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.wishesSteps.step_9);
    onReset(["communicationType"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.wishesSteps.buy.step_2);
  };

  return (
    <div>
      <CommunicateStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
      />
    </div>
  );
};

export default WishStepBuy_1;
